import { themeColor } from "./_helpers";

export const railTokens = {
  border: themeColor({
    base: "{colors.neutral.200}",
    _themeBlack: "{colors.whiteAlpha.200}",
    _themeWhite: "{colors.neutral.200}",
  }),
  activeBg: themeColor({
    base: "{colors.primary.50}",
    _themeBlack: "{colors.whiteAlpha.200}",
    _themeWhite: "{colors.primary.50}",
  }),
  hoverBg: themeColor({
    base: "{colors.whiteAlpha.400}",
    _themeBlack: "{colors.whiteAlpha.100}",
    _themeWhite: "{colors.primary.50}",
  }),
  icon: themeColor({
    base: "{colors.neutral.700}",
    _themeBlack: "{colors.neutral.300}",
    _themeWhite: "{colors.neutral.600}",
  }),
  iconActive: themeColor({
    base: "{colors.primary.600}",
    _themeBlack: "{colors.primary.400}",
    _themeWhite: "{colors.primary.600}",
  }),
  label: themeColor({
    base: "{colors.neutral.700}",
    _themeBlack: "{colors.neutral.300}",
    _themeWhite: "{colors.neutral.600}",
  }),
  labelActive: themeColor({
    base: "{colors.primary.600}",
    _themeBlack: "{colors.primary.300}",
    _themeWhite: "{colors.primary.600}",
  }),
};
